import { render, staticRenderFns } from "./UsePlatformGraphic.vue?vue&type=template&id=31a53d04"
import script from "./UsePlatformGraphic.vue?vue&type=script&lang=js"
export * from "./UsePlatformGraphic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports